import { render, staticRenderFns } from "./Localisation.vue?vue&type=template&id=2869a984&scoped=true"
import script from "./Localisation.vue?vue&type=script&lang=js"
export * from "./Localisation.vue?vue&type=script&lang=js"
import style0 from "./Localisation.vue?vue&type=style&index=0&id=2869a984&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2869a984",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2869a984')) {
      api.createRecord('2869a984', component.options)
    } else {
      api.reload('2869a984', component.options)
    }
    module.hot.accept("./Localisation.vue?vue&type=template&id=2869a984&scoped=true", function () {
      api.rerender('2869a984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Localisation/Localisation.vue"
export default component.exports